import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SkillRule } from "@app/models/rest/skill-rule";

@Injectable({
  providedIn: "root"
})
export class SkillRuleRestService extends HateoasResourceOperation<SkillRule> {
  constructor() {
    super(SkillRule);
  }
}
